import React from 'react'
import VehicleMakeModelImage from './VehicleMakeModelImage'
import { FaTrashAlt } from '@react-icons/all-files/fa/FaTrashAlt'
import { FaPencilAlt } from '@react-icons/all-files/fa/FaPencilAlt'
import ActivityIndicator from './forms/ActivityIndicator'
import CircularCloseButton from './CircularCloseButton'
import { Helpers } from '../utilities/helpers'
import building_content_graphic from '../../assets/images/buildings-and-contents-graphic.png'
import { productTypes } from '../utilities/enums'

const BasketItem = (props) => {
  const {
    type,
    registration,
    lowmileagePremium,
    comprehensivePremium,
    onPressRemove,
    loading,
    description = '',
    isEditable = false,
    onPressEdit,
    onPressReview,
    image,
    isRemoveable = true
  } = props

  const isMotorInsurance = type === productTypes.motor
  const isHouseholdContents = type === productTypes.homeContents

  return (
    <div className='basket-ledger-item-wrapper'>
      <div className='basket-ledger-img-wrapper'>
        {isMotorInsurance && <VehicleMakeModelImage image={image} isImgPadded={true} />}
        {isHouseholdContents && <img src={building_content_graphic} alt="Household Contents" style={{ height: '70%', objectFit: 'contain', marginBottom: '10px' }} />}
        {isMotorInsurance && <div className="tool-tip-registration-container">
          <p className='registration-heading'>{Helpers.displayReg(registration)}</p>
          {
            registration?.length > 8 ? (
              <span className="tool-tip-registration">{registration}</span>
            ) : (null)
          }
        </div>}
        {isHouseholdContents && <div className="tool-tip-registration-container">
          <p className='registration-heading'>{description}</p>
        </div>}
      </div>
      <div className='basket-ledger-details-wrapper'>
        { isMotorInsurance &&
          <div className='basket-ledger-premiums-wrapper'>
          <div className='basket-ledger-premiums-wrapper-left'>
            <p className='mileage-heading'>Under 300KM <sub className='mileage-heading-subscript'>P/M</sub></p>
            <p className='premium-heading'>{`R${parseFloat(lowmileagePremium).toFixed(2)}`}</p>
          </div>
          <div className='basket-ledger-premiums-wrapper-right'>
            <p className='mileage-heading'>Over 300KM <sub className='mileage-heading-subscript'>P/M</sub></p>
            <p className='premium-heading'>{`R${parseFloat(comprehensivePremium).toFixed(2)}`}</p>
          </div>
        </div>}
        {isHouseholdContents && 
          <div className='basket-ledger-premiums-wrapper'>
          <div className='home-contents-basket-ledger-premiums-wrapper-left'>
              <p className='mileage-heading'><sub className='mileage-heading-subscript'></sub></p>
              <p className='premium-heading'></p>
            </div>
            <div className='home-contents-basket-ledger-premiums-wrapper-right'>

            <p className='mileage-heading'>Premium <sub className='mileage-heading-subscript'>P/M</sub></p>
            <p className='premium-heading'>{`R${parseFloat(comprehensivePremium).toFixed(2)}`}</p>
            </div>
        </div>}
        {onPressReview && <p onClick={() => onPressReview()} className='basket-ledger-review-link'>Review Details</p>}
      </div>
      {isEditable ?
        <div className='basket-item-actions-wrapper'>
          <div className='basket-item-action-parent-wrapper'>
            <div className='basket-item-action-btn-wrapper'>
              <FaPencilAlt style={{ fontSize: '19px', color: '#000000', fontWeight: '900' }} onClick={() => onPressEdit()} />
            </div>
            <p className='basket-item-action-label'>Edit</p>
          </div>
          <div className='basket-item-action-parent-wrapper'>
            <div className='basket-item-action-btn-wrapper'>
              <FaTrashAlt style={{ fontSize: '19px', color: '#000000', fontWeight: '900' }} onClick={() => onPressRemove()} />
            </div>
            <p className='basket-item-action-label'>Delete</p>
          </div>
        </div>
        :
        <div>
          {
            loading ?
              <div className='basket-remove-btn-wrapper'>
                <ActivityIndicator style={{ fontSize: 15 }} color="#000" />
              </div>
              :
              isRemoveable ?
              <div className='basket-remove-btn-wrapper'>
                  <CircularCloseButton onClick={() => onPressRemove()} />
              </div> : null
          }
        </div>
      }
    </div>
  )
}

export default BasketItem